export const CommentBubbleMarginSize = 48;
export const CommentBubbleLargeRadius = 18;
export const CommentBubbleSmallRadius = 4;
export const CommentBubbleHorizontalPadding = 14;
export const CommentBubbleVerticalPadding = 9;
export const CommentBubbleRepliesAttachmentHeight = 24;

export const CommentSmallImageHeight = 60;
export const ContentSmallImageVerticalOffset = -0.6 * CommentSmallImageHeight;
export const CommentSmallImageHeightBoundingBox =
	CommentSmallImageHeight + ContentSmallImageVerticalOffset + 10;
